<dx-popup
    #depositDetailBox
    [title]="popupTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="deposit-content">
        <dx-box class="cc-view-deposit-container" height="100%" width="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="2">
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate class="font-bold">
                            <span>{{ depositDetails?.postDate | date: dateFormat }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item>
                        <dxo-label text="Bank Account"></dxo-label>
                        <div *dxTemplate class="font-bold">
                            {{ bankAccount }}
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item>
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate class="font-bold">
                            {{ currencyFormatter(depositDetails?.amount) }}
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item>
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate class="font-bold">
                            {{ depositDetails?.description }}
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'CB_DEP_LINE_ITEM_GRID' }"
                    [dataSource]="depositSourceItems"
                >
                    <dx-data-grid #depositDataGrid width="100%" height="100%" [dataSource]="depositSourceItems">
                        <dxi-column caption="Included In Deposit" cellTemplate="includedInDepositTemplate"></dxi-column>
                        <dxi-column
                            dataType="string"
                            dataField="source"
                            caption="Source"
                            cellTemplate="sourceCellTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataType="date"
                            dataField="receivedDate"
                            caption="Receive Date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <!--As per Sandeep's comment adding transaction date as post Date -->
                        <dxi-column
                            dataType="date"
                            dataField="transactionDate"
                            caption="Post Date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="amount"
                            caption="Amount"
                            dataType="number"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column dataType="string" dataField="description" caption="Description"></dxi-column>
                        <dxi-column
                            dataType="string"
                            dataField="payer"
                            caption="Payer"
                            cellTemplate="propertyCellTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataType="date"
                            dataField="transactionDate"
                            caption="Transaction Date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <dxi-column
                            dataType="string"
                            dataField="transactionNumber"
                            caption="Transaction Number"
                        ></dxi-column>
                        <div *dxTemplate="let row of 'propertyCellTemplate'">
                            <app-property-community-link
                                [communityId]="depositParams?.communityId"
                                [customerId]="row.value"
                                [displayText]="row.value"
                            ></app-property-community-link>
                        </div>

                        <div *dxTemplate="let data of 'includedInDepositTemplate'">
                            <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                        </div>

                        <div *dxTemplate="let row of 'sourceCellTemplate'">
                            <app-hyperlink-creator
                                [displayText]="row.text"
                                (onLinkClick)="onSourceItemClick(row.data)"
                            ></app-hyperlink-creator>
                        </div>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-button text="Close" type="default" [icon]="iconClose" (onClick)="onHidden()"></dx-button>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#depositDetailBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
